import { render, staticRenderFns } from "./Presentations.vue?vue&type=template&id=355366bc&scoped=true"
import script from "./Presentations.vue?vue&type=script&lang=js"
export * from "./Presentations.vue?vue&type=script&lang=js"
import style0 from "./Presentations.vue?vue&type=style&index=0&id=355366bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355366bc",
  null
  
)

export default component.exports